module.exports = __webpack_public_path__ + "static/media/mzprotradainglogo.ce5df3d4.png";